export default "__VITE_ASSET__f8bedc8c__"